import * as React from 'react'

import { cn } from '@/lib/utils' // Optional: for conditional class names

export interface ContextMenuOption {
	label: string
	onClick: () => void
}

interface Props {
	contextMenuOptions: ContextMenuOption[]
	transform: string
	left: number
	// Optional className to allow further customization
	className?: string
}

const AstaRightClickMenu: React.FC<Props> = ({
	contextMenuOptions,
	transform,
	left,
	className,
}) => {
	// The dynamic positioning is handled by the style prop, which is the correct
	// approach for values calculated on the fly.
	const menuStyle = {
		transform,
		// The original code had a hardcoded offset of 100.
		// This can be adjusted as needed.
		left: left - 100,
	}

	return (
		<div
			style={menuStyle}
			className={cn(
				// Base styles mimicking shadcn/ui's ContextMenuContent
				'absolute z-50 flex w-52 flex-col overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md',
				className
			)}
			role="menu"
		>
			{contextMenuOptions.map(option => (
				<div
					key={option.label}
					onClick={option.onClick}
					className="relative flex min-h-[34px] cursor-pointer select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none hover:bg-accent focus:bg-accent"
					role="menuitem"
					tabIndex={-1} // Makes it focusable but not part of the tab order
				>
					{option.label}
				</div>
			))}
		</div>
	)
}

export default AstaRightClickMenu
